var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import debounce from "debounce-promise";
import { observable } from "mobx";
export class HXAutocompleteViewModel {
    constructor(opts) {
        var _a, _b;
        this.minLengthBeforeSearch = 0;
        this.inputValue = "";
        this.options = [];
        if (opts.loadOptions) {
            const loadOptions = opts.loadOptions;
            this.loadOptionsDebounced = debounce(async () => {
                const options = await loadOptions(this.inputValue);
                this.options = options;
            }, 300);
        }
        else {
            this.staticOptions = (_a = opts.options) !== null && _a !== void 0 ? _a : [];
            this.options = this.staticOptions;
        }
        this.minLengthBeforeSearch = (_b = opts.minLengthBeforeSearch) !== null && _b !== void 0 ? _b : 3;
        if (this.minLengthBeforeSearch === 0) {
            this.setInputValue("");
        }
    }
    updateOpts(opts) {
        var _a;
        this.staticOptions = (_a = opts.options) !== null && _a !== void 0 ? _a : [];
        this.options = this.staticOptions;
    }
    setInputValue(inputValue) {
        this.inputValue = inputValue;
        if (this.loadOptionsDebounced) {
            if (this.inputValue.length < this.minLengthBeforeSearch) {
                this.options = [];
            }
            else {
                void this.loadOptionsDebounced();
            }
        }
    }
}
__decorate([
    observable
], HXAutocompleteViewModel.prototype, "inputValue", void 0);
__decorate([
    observable
], HXAutocompleteViewModel.prototype, "options", void 0);
